import React, { ReactNode, useMemo, useState } from "react";
import styles from "./Layout.module.scss";
import Header from "./Header/Header";
import { TabsPanel } from "../../components/Tabs";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import Footer from "./Footer/Footer";

const Layout = ({ children }: { children?: ReactNode }) => {
  const currentUser = useSelector((state: RootState) => state.user.user);

  const [activeTab, setActiveTab] = useState("");
  const isAdmin = currentUser.features.includes("Admin");

  const callBack = (tabName: string) => {
    setActiveTab(tabName);
  };

  const tabTypes = useMemo(
    () =>
      [
        { name: "Home", url: "/home", content: <div>Home Content</div> },
        {
          name: "Analysis",
          url: "/analysis",
          content: <div>Analysis Content</div>,
        },
        // {
        //   name: "Prospecting",
        //   url: "/prospecting/findfleet",
        //   content: <div>Prospecting Content</div>,
        //   isDisabled: false,
        // },
        { name: "Admin", url: "/admin", content: <div>Admin Content</div> },
      ].filter((tab) => isAdmin || tab.name !== "Admin"),
    [isAdmin],
  );

  const tabsPanelProps = {
    tabs: tabTypes.map((type) => ({
      name: type.name,
      content: type.content,
      url: type.url,
      //   isDisabled: type.isDisabled || false,
      isDisabled: false,
    })),
    baseClassName: "header",
    activeTab: activeTab,
    scrollToTopEnable: false,
    callback: callBack,
  };
  return (
    <div className={styles.layout}>
      <Header />
      <TabsPanel
        tabs={tabsPanelProps.tabs}
        activeTab={activeTab}
        baseClassName={tabsPanelProps.baseClassName}
        callback={callBack}
      />
      <div
        style={{
          flex: 1,
          width: "100%",
          height: "100%",
          maxHeight: "100%",
          overflow: "hidden",
        }}
      >
        {children}
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
